import { render, staticRenderFns } from "./VueFormulateResizableTextarea.vue?vue&type=template&id=6b16c54c&scoped=true"
import script from "./VueFormulateResizableTextarea.vue?vue&type=script&lang=js"
export * from "./VueFormulateResizableTextarea.vue?vue&type=script&lang=js"
import style0 from "./VueFormulateResizableTextarea.vue?vue&type=style&index=0&id=6b16c54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b16c54c",
  null
  
)

export default component.exports